import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalises legacy plain-text content (saved before rich-text editors existed)
 * into simple HTML so newlines survive innerHTML rendering.
 * Content that already contains HTML tags is returned unchanged.
 */
export function ensureRichText(value?: string | null): string {
  if (!value) return "";
  if (/<[a-z][\s\S]*>/i.test(value)) return value;
  return value
    .split(/\n{2,}/)
    .map((block) => `<p>${block.replace(/\n/g, "<br />")}</p>`)
    .join("");
}

/**
 * Label shown on a post/task link button. Falls back to the readable host name
 * (e.g. "linkedin.com") when no label was saved, instead of a generic wording.
 */
export function linkLabel(url: string, title?: string | null): string {
  if (title && title.trim()) return title.trim();
  try {
    const host = new URL(url).hostname.replace(/^www\./, "");
    return host === "lnkd.in" ? "linkedin.com" : host;
  } catch {
    return "Open link";
  }
}
